/**
 * The browser's Supabase client, made once. Everything that needs auth or
 * storage imports this rather than constructing its own, so there is one
 * session and one listener; `lib/api` signs its requests from it, and the
 * spotlight loaders sign their URLs through it.
 */

import { createBrowserClient } from "@ondo/supabase/browser";

/**
 * Single browser client for the app. `import.meta.env` is populated by Vite
 * from the root .env, limited to CLIENT_ENV_KEYS.
 */
export const supabase = createBrowserClient(
  import.meta.env as unknown as Record<string, unknown>,
);
